import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_interaction_Modify from 'ol/interaction/Modify';
import { Util } from "../util";
import Map from '../map';
export class Modify extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            condition: undefined,
            deleteCondition: undefined,
            pixelTolerance: undefined,
            style: undefined,
            features: undefined,
            wrapX: undefined
        };
        this.events = {
            'change': undefined,
            'change:active': undefined,
            'modifyend': undefined,
            'modifystart': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        console.log('options', options);
        this.interaction = new ol_interaction_Modify(options);
        this.context.mapComp.interactions.push(this.interaction);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.interaction.on(eventName, olEvents[eventName]);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.context.mapComp.map.removeInteraction(this.interaction);
            let options = Util.getOptions(Object['assign'](this.options, nextProps));
            this.interaction = new ol_interaction_Modify(options);
            this.context.mapComp.map.addInteraction(this.interaction);
            let olEvents = Util.getEvents(this.events, this.props);
            for (let eventName in olEvents) {
                this.interaction.on(eventName, olEvents[eventName]);
            }
        }
    }
    componentWillUnmount() {
        this.context.mapComp.map.removeInteraction(this.interaction);
    }
}
Modify['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};